import { defineComponent as _defineComponent } from 'vue';
import { DropdownMenuTrigger } from 'reka-ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuTrigger',
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { get DropdownMenuTrigger() { return DropdownMenuTrigger; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
